import { render, staticRenderFns } from "./Deduction.vue?vue&type=template&id=1b47c202&scoped=true"
import script from "./Deduction.vue?vue&type=script&lang=js"
export * from "./Deduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47c202",
  null
  
)

export default component.exports